import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { createCorriere, getCorriere, getBanche } from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';


// Stessa formula del backend (Corriere.costo_netto_effettivo): costo ivato meno sconto ricariche, senza IVA se detraibile
const costoNettoStimato = (f) => {
  const ivato = parseFloat(f.costo_ivato);
  if (!ivato) return parseFloat(f.costo) ? Number(f.costo).toFixed(2) : '—';
  const scontato = ivato * (1 - (parseFloat(f.sconto_ricarica_pct) || 0) / 100);
  return (f.iva_detraibile === false ? scontato : scontato / 1.22).toFixed(2);
};

const NuovoCorriere = () => {
  const initialFormData = {
    denominazione: '',
    telefono: '',
    cellulare: '',
    tipo_spedizione: '',
    costo: '', // New field
    costo_ivato: null,
    sconto_ricarica_pct: 0,
    iva_detraibile: true,
    referente: '',
    mirakl_carrier_code: '',
    codice_logica: '',
    banca_pagamento_id: null,
    paccofacile_service_id: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [banche, setBanche] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch banche
        const bancheRes = await getBanche(0, 1000);
        setBanche(bancheRes.data.banche);

        // Check for duplication
        const queryParams = new URLSearchParams(location.search);
        const duplicateId = queryParams.get('duplicateId');

        if (duplicateId) {
          const response = await getCorriere(parseInt(duplicateId));
          const duplicatedCorriere = response.data;

          setFormData({
            ...duplicatedCorriere,
            id: undefined,
            denominazione: duplicatedCorriere.denominazione ? `${duplicatedCorriere.denominazione} (Copia)` : null,
          });
          navigate(location.pathname, { replace: true });
        }
      } catch (error) {
        console.error("Errore durante il caricamento dei dati:", error);
        alert("Errore durante il caricamento dei dati iniziali.");
      }
    };

    fetchData();
  }, [location.search, navigate, location.pathname]);

  const handleBancaChange = (selected) => {
    const bancaId = selected.length > 0 ? selected[0].id : null;
    setFormData({
        ...formData,
        banca_pagamento_id: bancaId
    });
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let processedValue = value;

    if (name === 'email') {
      processedValue = value ? value : null; // Convert any falsy value (like '', undefined, null) to null
    } else if (type === 'number') {
      processedValue = value === '' ? null : parseFloat(value);
    } else if (value === '') {
      processedValue = null;
    }

    setFormData({ 
        ...formData, 
        [name]: processedValue 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createCorriere(formData);
      alert('Corriere creato con successo!');
      navigate('/corrieri');
    } catch (error) {
      console.error('Errore nella creazione del corriere:', error.response || error);
      alert('Errore nella creazione del corriere.');
    }
  };

  return (
    <Container>
        <Row className="align-items-center mb-3">
            <Col>
                <h2>Nuovo Corriere</h2>
            </Col>
            <Col xs="auto" className="ms-auto">
                <Button variant="secondary" onClick={() => navigate('/corrieri')} className="me-2">
                    Torna alla Lista
                </Button>
                <Button variant="primary" type="submit" form="corriere-form">
                    Salva Corriere
                </Button>
            </Col>
        </Row>
      <Form id="corriere-form" onSubmit={handleSubmit}>
        <Card className="mb-4">
          <Card.Header>ANAGRAFICA</Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="formDenominazione">
              <Form.Label>Denominazione</Form.Label>
              <Form.Control type="text" name="denominazione" value={formData.denominazione} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formReferente">
              <Form.Label>Referente</Form.Label>
              <Form.Control type="text" name="referente" value={formData.referente} onChange={handleChange} />
            </Form.Group>



            <Row>
              <Col md={6}><Form.Group className="mb-3" controlId="formTelefono"><Form.Label>Telefono</Form.Label><Form.Control type="tel" name="telefono" value={formData.telefono} onChange={handleChange} placeholder="es. 06 / 1234567" /></Form.Group></Col>
              <Col md={6}><Form.Group className="mb-3" controlId="formCellulare"><Form.Label>Cellulare</Form.Label><Form.Control type="tel" name="cellulare" value={formData.cellulare} onChange={handleChange} placeholder="es. 333 / 1234567" /></Form.Group></Col>
            </Row>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Header>SPEDIZIONE E PAGAMENTO</Card.Header>
          <Card.Body>
            <Row>
                <Col md={6}><Form.Group className="mb-3" controlId="formTipoSpedizione"><Form.Label>Tipo Spedizione</Form.Label><Form.Control type="text" name="tipo_spedizione" value={formData.tipo_spedizione  || ''} onChange={handleChange} /></Form.Group></Col>
                <Col md={6}><Form.Group className="mb-3" controlId="formCosto"><Form.Label>Costo (storico, usato solo se il costo reale qui sotto è vuoto)</Form.Label><Form.Control type="number" step="0.01" name="costo" value={formData.costo  || ''} onChange={handleChange} /></Form.Group></Col>
                <Col md={4}><Form.Group className="mb-3" controlId="formCostoIvato"><Form.Label>Costo reale per spedizione (IVA compresa)</Form.Label><Form.Control type="number" step="0.01" name="costo_ivato" value={formData.costo_ivato ?? ''} onChange={handleChange} placeholder="es. 5.67" /></Form.Group></Col>
                <Col md={4}><Form.Group className="mb-3" controlId="formScontoRicarica"><Form.Label>Sconto sulle ricariche (%)</Form.Label><Form.Control type="number" step="0.1" name="sconto_ricarica_pct" value={formData.sconto_ricarica_pct ?? ''} onChange={handleChange} placeholder="es. 4" /></Form.Group></Col>
                <Col md={4}><Form.Group className="mb-3" controlId="formIvaDetraibile"><Form.Label>IVA sulla spedizione</Form.Label><Form.Check type="switch" name="iva_detraibile" label="Detraibile" checked={formData.iva_detraibile !== false} onChange={(e) => setFormData({ ...formData, iva_detraibile: e.target.checked })} /><Form.Text className="text-muted">Costo netto usato nei margini: {costoNettoStimato(formData)} €</Form.Text></Form.Group></Col>
                <Col md={6}><Form.Group className="mb-3" controlId="formMiraklCarrierCode"><Form.Label>Codice Corriere Mirakl</Form.Label><Form.Control type="text" name="mirakl_carrier_code" value={formData.mirakl_carrier_code || ''} onChange={handleChange} /></Form.Group></Col>
                <Col md={6}><Form.Group className="mb-3" controlId="formPaccofacileServiceId"><Form.Label>Service ID PaccoFacile</Form.Label><Form.Control type="text" name="paccofacile_service_id" value={formData.paccofacile_service_id || ''} onChange={handleChange} placeholder="es. 92 (Poste Crono), 38 (BRT Express)" /></Form.Group></Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formBancaPagamento">
                        <Form.Label>Banca di Pagamento</Form.Label>
                        <Typeahead
                            id="banca-pagamento-typeahead"
                            labelKey="denominazione"
                            options={banche}
                            placeholder="Seleziona una banca..."
                            onChange={handleBancaChange}
                            selected={banche.filter(b => b.id === formData.banca_pagamento_id)}
                            clearButton
                        />
                    </Form.Group>
                </Col>
            </Row>
          </Card.Body>
        </Card>


      </Form>
    </Container>
  );
};

export default NuovoCorriere;
